import { JourneyTrack } from "../journey-track";
import { TrackInfo } from "../model/track-info";
import { TrackTypes } from "../model/track-types";
import { DomainOrigin } from "../../../domains/model/domain-origin";
import { TrackActionResult } from "../model/track-action-result";
import { environment } from "../../../../../../environments/environment";
import { ContaIonDataParse } from "./util/conta-ion-data-parse";
import { BirthCountryAction } from "./actions/birth-country-action";
import { CacheService } from "../../../comunicator-native/cache/v2/cache.service";
import { MobileMockData } from "./util/mobile-mock-data";
import { TokenService } from "../../../token/token.service";
import { DomainFactoryService } from "../../../domains/domain-factory-service";
import { DomainDataType } from "../../../domains/model/domain-data-type";
import { LogService } from "../../../log/log.service";
import { Platform } from "@ionic/angular";

export class ContaIonPersonalTrack extends JourneyTrack {
  domainsForLoading = [
    DomainDataType.DocumentType,
    DomainDataType.Gender,
    DomainDataType.DocumentIssuing,
    DomainDataType.Nationality,
    DomainDataType.State,
    DomainDataType.Country,
  ];

  readonly originalTracks = [
    new TrackInfo(
      "document-type",
      ["personal-data", "document-type"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainOrigin] }
    ),
    new TrackInfo("document-name", ["personal-data", "document-name"]),
    new TrackInfo("document-number", ["personal-data", "document-number"]),
    new TrackInfo(
      "document-issuing",
      ["personal-data", "document-issuing"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainOrigin] }
    ),
    new TrackInfo(
      "expedition-state",
      ["personal-data", "expedition-state"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin] }
    ),

    new TrackInfo("parentage", ["personal-data", "parentage"]),
    new TrackInfo("nationality", ["personal-data", "nationality"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
    }),

    new TrackInfo(
      "birth-country",
      ["personal-data", "birth-country"],
      undefined,
      {
        domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin],
        actionName: ActionList.BirthCountry,
      }
    ),
    new TrackInfo("birth-state", ["personal-data", "birth-state"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin],
    }),
    new TrackInfo("birth-city", ["personal-data", "birth-city"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin],
    }),
    new TrackInfo("gender", ["personal-data", "gender"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
    }),
  ];

  track = [];

  constructor(
    private cacheNativeService: CacheService,
    public domainFactory: DomainFactoryService,
    private logService: LogService,
    private tokenService: TokenService,
    private platform: Platform
  ) {
    super();
    this.track = this.originalTracks;
  }

  getName(): TrackTypes {
    return TrackTypes.CONTA_ION_PERSONAL;
  }

  getTrack(): TrackInfo[] {
    return this.track;
  }

  public async loadData() {
    //MobileMockData.executeMockCall(500);

    const data = await this.cacheNativeService.getItemCommunicator();
    await this.tokenService.getToken();

    await this.getAllDomains();

    return Promise.resolve(ContaIonDataParse.parseFromMobileData(data));
  }

  public isUncoupled() {
    return true;
  }

  public executeAction(actionName, data): TrackActionResult {
    switch (actionName) {
      case ActionList.BirthCountry:
        return BirthCountryAction.execute(
          data,
          this.track,
          this.originalTracks
        );
    }
  }

  private async getAllDomains() {
    this.logService.save(
      "carregando dominios ",
      "OverviewComponent.getAllDomains"
    );

    for (let i = 0; i < this.domainsForLoading.length - 1; i++) {
      if (
        this.domainsForLoading[i] == DomainDataType.Country ||
        this.domainsForLoading[i] == DomainDataType.State
      ) {
        this.domainFactory
          .getDomainService(DomainOrigin[environment.contaIonDomainCityOrigin])
          .getDomains(
            this.domainsForLoading[i],
            this.domainsForLoading[i] == DomainDataType.State ? "BR" : undefined
          );
      } else {
        this.domainFactory
          .getDomainService(DomainOrigin[environment.contaIonDomainOrigin])
          .getDomains(this.domainsForLoading[i]);
      }
    }
    this.logService.save(
      "Dominios carregados ",
      "OverviewComponent.getAllDomains"
    );
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return this.platform.is("android");
  }
}

export enum ActionList {
  BirthCountry = "country",
}
